import { fetchService } from "./baseService";

export const sendEmailContactAgent = (data) =>
    fetchService(`public/listing/email`, {
        method: "POST",
        body: JSON.stringify(data)
    });